import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Observable } from 'rxjs';
import { ChangeLog } from 'app/models/change-log';
import { ChangeCodeEnum, ChangeLogContextEnum } from 'app/models/enums';

@Injectable()
export class ChangeLogService {

  constructor(private _http: Http) { }

  GetChangeLogs(user: string, customerId: string, context: ChangeLogContextEnum, changeCode: ChangeCodeEnum,
    sortBy: string, sortDir: string, page: number, pageSize: number): Observable<Array<ChangeLog>> {   
    
    return this._http.get('/api/changelog?userId=' + user + '&customerId=' + customerId + '&context=' + context 
    + '&changeCode=' + changeCode + '&sortBy=' + '' + '&sortDir=&page=' + page+ '&pageSize=' + pageSize)
      .map(this.extractData)
      .catch(this.handleError);
  }
 
  GetCount(user: string, customerId: string, context: ChangeLogContextEnum, changeCode: ChangeCodeEnum): Observable<number> {    
    return this._http.get('/api/changelog/getcount?userId=' + user + '&customerId=' + customerId + '&context=' + context 
    + '&changeCode=' + changeCode)
     .map(res => res.text())
     .catch(this.handleError);
 }

 GetByUserId(userId: string): Observable<ChangeLog> {    
    return this._http.get('/api/changelog/GetByUserId?userId=' + userId)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetByUserIdAndContext(userId: string, chgCtx: ChangeLogContextEnum): Observable<ChangeLog> {    
    return this._http.get('/api/changelog/GetByUserAndContext?userId=' + userId + '&chgCtx=' + chgCtx)
      .map(this.extractData)
      .catch(this.handleError);
  }

 private extractData(res: Response) {
  let data
  if (res.text()) {
    data = res.json();
  }
  return data || {};
}

private handleError(error: Response | any) {
  // In a real world app, we might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}

}



// WEBPACK FOOTER //
// ./src/app/services/change-log.service.ts